import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto",
    "margin": "0 auto",
    "float": "left"
  }
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 3
};
const _hoisted_9 = {
  key: 4
};
const _hoisted_10 = {
  key: 5
};
const _hoisted_11 = {
  key: 6
};
const _hoisted_12 = {
  key: 7
};
const _hoisted_13 = {
  key: 8
};
const _hoisted_14 = {
  key: 9
};
const _hoisted_15 = {
  key: 10
};
const _hoisted_16 = {
  key: 1,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_17 = {
  key: 0,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto",
    "margin": "0 auto",
    "float": "left"
  }
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 0
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  key: 2
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 3
};
const _hoisted_24 = {
  key: 4
};
const _hoisted_25 = {
  key: 5
};
const _hoisted_26 = {
  key: 6
};
const _hoisted_27 = {
  key: 7
};
const _hoisted_28 = {
  key: 8
};
const _hoisted_29 = {
  key: 9
};
const _hoisted_30 = {
  key: 10
};
const _hoisted_31 = {
  key: 2,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_32 = {
  key: 0,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto",
    "margin": "0 auto",
    "float": "left"
  }
};
const _hoisted_33 = {
  key: 0
};
const _hoisted_34 = {
  key: 0
};
const _hoisted_35 = {
  key: 1
};
const _hoisted_36 = {
  key: 2
};
const _hoisted_37 = {
  key: 0
};
const _hoisted_38 = {
  key: 3
};
const _hoisted_39 = {
  key: 4
};
const _hoisted_40 = {
  key: 5
};
const _hoisted_41 = {
  key: 6
};
const _hoisted_42 = {
  key: 7
};
const _hoisted_43 = {
  key: 8
};
const _hoisted_44 = {
  key: 9
};
const _hoisted_45 = {
  key: 10
};
const _hoisted_46 = {
  key: 3,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_47 = {
  key: 0,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto",
    "margin": "0 auto",
    "float": "left"
  }
};
const _hoisted_48 = {
  key: 0
};
const _hoisted_49 = {
  key: 0
};
const _hoisted_50 = {
  key: 1
};
const _hoisted_51 = {
  key: 2
};
const _hoisted_52 = {
  key: 3
};
const _hoisted_53 = {
  key: 4
};
const _hoisted_54 = {
  key: 5
};
const _hoisted_55 = {
  key: 6
};
const _hoisted_56 = {
  key: 0
};
const _hoisted_57 = {
  key: 7
};
const _hoisted_58 = {
  key: 8
};
const _hoisted_59 = {
  key: 9
};
const _hoisted_60 = {
  key: 10
};
const _hoisted_61 = {
  key: 4,
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_62 = {
  key: 0
};
const _hoisted_63 = {
  key: 0
};
const _hoisted_64 = {
  key: 1
};
const _hoisted_65 = {
  key: 2
};
const _hoisted_66 = {
  key: 3
};
const _hoisted_67 = {
  key: 4
};
const _hoisted_68 = {
  key: 5
};
const _hoisted_69 = {
  key: 6
};
const _hoisted_70 = {
  key: 7
};
const _hoisted_71 = {
  key: 8
};
const _hoisted_72 = {
  key: 0
};
const _hoisted_73 = {
  key: 9
};
const _hoisted_74 = {
  key: 0
};
const _hoisted_75 = {
  key: 10
};
const _hoisted_76 = {
  key: 11
};
const _hoisted_77 = {
  key: 12
};
const _hoisted_78 = {
  key: 13
};
const _hoisted_79 = {
  key: 0
};
const _hoisted_80 = {
  key: 1
};
const _hoisted_81 = {
  key: 2
};
const _hoisted_82 = {
  key: 3
};
const _hoisted_83 = {
  key: 4
};
const _hoisted_84 = {
  key: 5
};
const _hoisted_85 = {
  class: "demonstration",
  style: {
    "margin": "10px 0"
  }
};
const _hoisted_86 = {
  align: "left",
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_87 = {
  class: "dialog-footer"
};
const _hoisted_88 = {
  class: "demo-image__lazy"
};
const _hoisted_89 = {
  id: "app",
  style: {
    "margin-left": "150px"
  }
};
const _hoisted_90 = {
  class: "items"
};
const _hoisted_91 = {
  class: "item-right",
  style: {
    "font-size": "13px"
  }
};
const _hoisted_92 = {
  class: "person"
};
const _hoisted_93 = {
  class: "content",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_94 = {
  class: "time",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_95 = {
  id: "app2",
  style: {
    "margin-left": "150px"
  }
};
const _hoisted_96 = {
  class: "items"
};
const _hoisted_97 = {
  class: "item-right",
  style: {
    "font-size": "13px"
  }
};
const _hoisted_98 = {
  class: "person"
};
const _hoisted_99 = {
  class: "content",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_100 = {
  class: "time",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_101 = {
  id: "app3",
  style: {
    "margin-left": "150px"
  }
};
const _hoisted_102 = {
  class: "items"
};
const _hoisted_103 = {
  class: "item-right",
  style: {
    "font-size": "13px"
  }
};
const _hoisted_104 = {
  class: "person"
};
const _hoisted_105 = {
  class: "content",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_106 = {
  class: "time",
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_107 = {
  class: "dialog-footer"
};
const _hoisted_108 = {
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_109 = {
  class: "dialog-footer"
};
const _hoisted_110 = {
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_111 = {
  class: "dialog-footer"
};
const _hoisted_112 = {
  style: {
    "position": "relative",
    "width": "auto",
    "height": "auto"
  }
};
const _hoisted_113 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_main = _resolveComponent("el-main");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_footer = _resolveComponent("el-footer");
  const _component_el_container = _resolveComponent("el-container");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_radio_button = _resolveComponent("el-radio-button");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_el_container, null, {
    default: _withCtx(() => [this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("table", _hoisted_2, [_createElementVNode("tr", null, [this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_3, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {},
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[0] || (_cache[0] = $event => $options.Audit($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_4, "提交审核")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_5, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[1] || (_cache[1] = $event => $options.Rollback($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[101] || (_cache[101] = [_createElementVNode("span", null, "回退", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_6, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[2] || (_cache[2] = $event => $options.showlc($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, "查流程")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_8, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[3] || (_cache[3] = $event => $options.ReportDetails($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[102] || (_cache[102] = [_createTextVNode("报告详情 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_9, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[4] || (_cache[4] = $event => $options.ReportQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[103] || (_cache[103] = [_createTextVNode("记录查询 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_10, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[5] || (_cache[5] = $event => $options.NoticeQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[104] || (_cache[104] = [_createTextVNode("备忘录 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_11, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[6] || (_cache[6] = $event => $options.VideoQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[105] || (_cache[105] = [_createTextVNode("检测视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_12, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[7] || (_cache[7] = $event => $options.PictureQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[106] || (_cache[106] = [_createTextVNode("检测图片 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_13, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[8] || (_cache[8] = $event => $options.VideoUpload($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[107] || (_cache[107] = [_createTextVNode("上传视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_14, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.showQuery
    }, {
      default: _withCtx(() => [...(_cache[108] || (_cache[108] = [_createTextVNode("查询条件 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 0 ? (_openBlock(), _createElementBlock("td", _hoisted_15, [this.RecordFlag == 0 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.flushPage
    }, {
      default: _withCtx(() => [...(_cache[109] || (_cache[109] = [_createTextVNode("刷新 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("table", _hoisted_17, [_createElementVNode("tr", null, [this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_18, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {},
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[9] || (_cache[9] = $event => $options.OpenShsj($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_19, "审核")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_20, [_withDirectives(_createVNode(_component_el_button, {
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[10] || (_cache[10] = $event => $options.Qualified($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[110] || (_cache[110] = [_createTextVNode("退回 ", -1)]))]),
      _: 1
    }, 512), [[_vShow, this.RecordFlag == 5]])])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_21, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[11] || (_cache[11] = $event => $options.showlc($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "查流程")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_23, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[12] || (_cache[12] = $event => $options.ReportDetails($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[111] || (_cache[111] = [_createTextVNode("报告详情 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_24, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[13] || (_cache[13] = $event => $options.ReportQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[112] || (_cache[112] = [_createTextVNode("记录查询 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_25, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[14] || (_cache[14] = $event => $options.NoticeQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[113] || (_cache[113] = [_createTextVNode("备忘录 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_26, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[15] || (_cache[15] = $event => $options.VideoQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[114] || (_cache[114] = [_createTextVNode("检测视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_27, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[16] || (_cache[16] = $event => $options.PictureQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[115] || (_cache[115] = [_createTextVNode("检测图片 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_28, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[17] || (_cache[17] = $event => $options.VideoUpload($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[116] || (_cache[116] = [_createTextVNode("上传视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_29, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.showQuery
    }, {
      default: _withCtx(() => [...(_cache[117] || (_cache[117] = [_createTextVNode("查询条件 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 5 ? (_openBlock(), _createElementBlock("td", _hoisted_30, [this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.flushPage
    }, {
      default: _withCtx(() => [...(_cache[118] || (_cache[118] = [_createTextVNode("刷新 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("table", _hoisted_32, [_createElementVNode("tr", null, [this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_33, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {},
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[18] || (_cache[18] = $event => $options.OpenPzsj($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_34, "批准")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_35, [_withDirectives(_createVNode(_component_el_button, {
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[19] || (_cache[19] = $event => $options.Qualified($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[119] || (_cache[119] = [_createTextVNode("退回 ", -1)]))]),
      _: 1
    }, 512), [[_vShow, this.RecordFlag == 2]])])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_36, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[20] || (_cache[20] = $event => $options.showlc($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_37, "查流程")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_38, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[21] || (_cache[21] = $event => $options.ReportDetails($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[120] || (_cache[120] = [_createTextVNode("报告详情 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_39, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[22] || (_cache[22] = $event => $options.ReportQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[121] || (_cache[121] = [_createTextVNode("记录查询 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_40, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[23] || (_cache[23] = $event => $options.NoticeQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[122] || (_cache[122] = [_createTextVNode("备忘录 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_41, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[24] || (_cache[24] = $event => $options.VideoQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[123] || (_cache[123] = [_createTextVNode("检测视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_42, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[25] || (_cache[25] = $event => $options.PictureQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[124] || (_cache[124] = [_createTextVNode("检测图片 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_43, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[26] || (_cache[26] = $event => $options.VideoUpload($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[125] || (_cache[125] = [_createTextVNode("上传视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_44, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.showQuery
    }, {
      default: _withCtx(() => [...(_cache[126] || (_cache[126] = [_createTextVNode("查询条件 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createElementBlock("td", _hoisted_45, [this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.flushPage
    }, {
      default: _withCtx(() => [...(_cache[127] || (_cache[127] = [_createTextVNode("刷新 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("table", _hoisted_47, [_createElementVNode("tr", null, [this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_48, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[27] || (_cache[27] = $event => $options.showlc($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_49, "查流程")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_50, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[28] || (_cache[28] = $event => $options.ReportDetails($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[128] || (_cache[128] = [_createTextVNode("报告详情 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_51, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[29] || (_cache[29] = $event => $options.ReportQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[129] || (_cache[129] = [_createTextVNode("记录查询 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_52, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[30] || (_cache[30] = $event => $options.NoticeQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[130] || (_cache[130] = [_createTextVNode("备忘录 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_53, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[31] || (_cache[31] = $event => $options.VideoQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[131] || (_cache[131] = [_createTextVNode("检测视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_54, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[32] || (_cache[32] = $event => $options.PictureQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[132] || (_cache[132] = [_createTextVNode("检测图片 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_55, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[33] || (_cache[33] = $event => $options.VideoUpload($data.scopedata)),
      disabled: $data.gaiz
    }, {
      default: _withCtx(() => [this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_56, "上传视频")) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["disabled"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_57, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.showQuery
    }, {
      default: _withCtx(() => [...(_cache[133] || (_cache[133] = [_createTextVNode("查询条件 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_58, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.flushPage
    }, {
      default: _withCtx(() => [...(_cache[134] || (_cache[134] = [_createTextVNode("刷新 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_59, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[34] || (_cache[34] = $event => $options.exportDate())
    }, {
      default: _withCtx(() => [...(_cache[135] || (_cache[135] = [_createTextVNode("导出数据", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 3 ? (_openBlock(), _createElementBlock("td", _hoisted_60, [this.RecordFlag == 3 && this.authList.indexOf('17') !== -1 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[35] || (_cache[35] = $event => $options.tuihui($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[136] || (_cache[136] = [_createTextVNode("退回未上传", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createElementVNode("tr", null, [this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_62, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      plain: "",
      size: "small",
      onClick: _cache[36] || (_cache[36] = $event => $options.Audit($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_63, "上传")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_64, [_withDirectives(_createVNode(_component_el_button, {
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[37] || (_cache[37] = $event => $options.Qualified($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[137] || (_cache[137] = [_createTextVNode("退回 ", -1)]))]),
      _: 1
    }, 512), [[_vShow, this.RecordFlag == 4]])])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_65, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[38] || (_cache[38] = $event => $options.Audit3($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[138] || (_cache[138] = [_createTextVNode("新规上传 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_66, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[39] || (_cache[39] = $event => $options.ReportDetails($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[139] || (_cache[139] = [_createTextVNode("报告详情 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_67, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[40] || (_cache[40] = $event => $options.ReportQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[140] || (_cache[140] = [_createTextVNode("记录查询 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_68, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[41] || (_cache[41] = $event => $options.NoticeQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[141] || (_cache[141] = [_createTextVNode("备忘录 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_69, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[42] || (_cache[42] = $event => $options.VideoQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[142] || (_cache[142] = [_createTextVNode("检测视频 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_70, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[43] || (_cache[43] = $event => $options.PictureQuery($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[143] || (_cache[143] = [_createTextVNode("检测图片 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_71, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[44] || (_cache[44] = $event => $options.VideoUpload($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_72, "上传视频")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_73, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      type: "primary",
      size: "small",
      plain: "",
      onClick: _cache[45] || (_cache[45] = $event => $options.ToSeal($data.scopedata))
    }, {
      default: _withCtx(() => [this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_74, "盖章")) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_75, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.showQuery
    }, {
      default: _withCtx(() => [...(_cache[144] || (_cache[144] = [_createTextVNode("查询条件 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_76, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: $options.flushPage
    }, {
      default: _withCtx(() => [...(_cache[145] || (_cache[145] = [_createTextVNode("刷新 ", -1)]))]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_77, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[46] || (_cache[46] = $event => $options.Audit2($data.scopedata, 0))
    }, {
      default: _withCtx(() => [...(_cache[146] || (_cache[146] = [_createTextVNode("重新上传 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), this.RecordFlag == 4 ? (_openBlock(), _createElementBlock("td", _hoisted_78, [this.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-left": "10px"
      },
      size: "small",
      type: "primary",
      plain: "",
      onClick: _cache[47] || (_cache[47] = $event => $options.Audit2($data.scopedata, 1))
    }, {
      default: _withCtx(() => [...(_cache[147] || (_cache[147] = [_createTextVNode("改1重传 ", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true), _createVNode(_component_el_main, {
      style: {
        "position": "relative"
      }
    }, {
      default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "element-loading-text": "加载中...",
        "element-loading-spinner": "el-icon-loading",
        data: $data.tableData,
        style: {
          "width": "100%",
          "height": "50vh"
        },
        border: "",
        ref: "table",
        "cell-class-name": $options.tableRowClassName,
        onCellClick: $options.handleCellClick,
        "highlight-current-row": ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "recStatus",
          "min-width": "120",
          "max-width": "200",
          label: "状态"
        }, {
          default: _withCtx(scope => [scope.row.recStatus == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_79, "初检")) : _createCommentVNode("", true), scope.row.recStatus == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_80, "重新编辑")) : _createCommentVNode("", true), scope.row.recStatus == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_81, "已审核")) : _createCommentVNode("", true), scope.row.recStatus == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_82, "已批准")) : _createCommentVNode("", true), scope.row.recStatus == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_83, "已上传")) : _createCommentVNode("", true), scope.row.recStatus == 5 ? (_openBlock(), _createElementBlock("span", _hoisted_84, "编制")) : _createCommentVNode("", true)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "liftNum",
          "min-width": "120",
          "max-width": "200",
          label: "产品编号"
        }), _createVNode(_component_el_table_column, {
          prop: "unit",
          "min-width": "220",
          "max-width": "300",
          label: "使用单位"
        }), _createVNode(_component_el_table_column, {
          prop: "loginNum",
          "min-width": "120",
          "max-width": "200",
          label: "登记证编号"
        }), _createVNode(_component_el_table_column, {
          prop: "areaName",
          "min-width": "120",
          "max-width": "200",
          label: "区域名称"
        }), _createVNode(_component_el_table_column, {
          prop: "userAlias",
          "min-width": "120",
          "max-width": "200",
          label: "检测人员"
        }), _createVNode(_component_el_table_column, {
          "show-overflow-tooltip": "",
          prop: "recDate",
          "min-width": "120",
          "max-width": "200",
          sortable: "",
          label: "检测时间"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(this.formatDate(scope.row.recDate, "yyyy-MM-dd")), 1)]),
          _: 1
        }), this.RecordFlag == 5 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 0,
          "show-overflow-tooltip": "",
          prop: "plaitDate",
          "min-width": "120",
          "max-width": "200",
          sortable: "",
          label: "提交审核时间"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(this.formatDate(scope.row.plaitDate, "yyyy-MM-dd")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), this.RecordFlag == 2 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 1,
          "show-overflow-tooltip": "",
          prop: "processDate",
          "min-width": "120",
          "max-width": "200",
          sortable: "",
          label: "审核时间"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(this.formatDate(scope.row.processDate, "yyyy-MM-dd")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), this.RecordFlag == 4 || this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 2,
          "show-overflow-tooltip": "",
          prop: "ratifyData",
          "min-width": "120",
          "max-width": "200",
          sortable: "",
          label: "批准时间"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(this.formatDate(scope.row.ratifyData, "yyyy-MM-dd")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), this.RecordFlag == 4 || this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
          key: 3,
          "show-overflow-tooltip": "",
          prop: "uploadDate",
          "min-width": "120",
          "max-width": "200",
          sortable: "",
          label: "上传时间"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(this.formatDate(scope.row.uploadDate, "yyyy-MM-dd")), 1)]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
          prop: "rejectDetail",
          "min-width": "120",
          "max-width": "200",
          label: "退回原因"
        }), _createVNode(_component_el_table_column, {
          prop: "videoUrl",
          "min-width": "120",
          "max-width": "200",
          label: "检测视频是否存在"
        }, {
          default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.videoUrl != null && scope.row.videoUrl != "" ? '存在' : '不存在'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "superviseCode",
          "min-width": "120",
          "max-width": "200",
          fixed: "right",
          label: "监察识别码"
        })]),
        _: 1
      }, 8, ["data", "cell-class-name", "onCellClick"])), [[_directive_loading, $data.loadang]])]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_85, [_createVNode(_component_el_pagination, {
        currentPage: $data.currentPage,
        "onUpdate:currentPage": _cache[48] || (_cache[48] = $event => $data.currentPage = $event),
        "page-size": $data.pageSize,
        "onUpdate:pageSize": _cache[49] || (_cache[49] = $event => $data.pageSize = $event),
        "page-sizes": [20, 40, 60],
        small: $data.small,
        background: $data.background,
        layout: "total, sizes, prev, pager, next, jumper",
        total: $data.total,
        prev: $data.prev,
        pager: $data.pager,
        next: $data.next,
        jumper: $data.jumper,
        onSizeChange: $options.handleSizeChange,
        onCurrentChange: $options.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "small", "background", "total", "prev", "pager", "next", "jumper", "onSizeChange", "onCurrentChange"])])]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogFormVisible,
    "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => $data.dialogFormVisible = $event),
    title: "查看检测记录",
    width: "60%"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_86, [_createVNode(_component_el_descriptions, {
      column: 2,
      border: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
        label: "创建人"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.createBy), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "创建时间"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(this.formatDate($data.theOne.createDate, "yyyy-MM-dd hh:mm:ss")), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "制造单位"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.DeviceList[0].createUnit), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "制造日期"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(this.formatDate($data.theOne.DeviceList[0].createDate, "yyyy-MM-dd hh:mm:ss")), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "使用单位"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.areaName), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "设备使用地点"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.sceneName), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "设备品种"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.DeviceList[0].liftType), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "检测日期"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(this.formatDate($data.theOne.recDate, "yyyy-MM-dd hh:mm:ss")), 1)]),
        _: 1
      }), _createVNode(_component_el_descriptions_item, {
        label: "检测模板"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString($data.theOne.templateName === '' ? '暂无数据' : $data.theOne.templateName) + " --＞" + _toDisplayString($data.theOne.maxtermName === '' ? '暂无数据' : $data.theOne.maxtermName) + "--＞" + _toDisplayString($data.theOne.sceneName === '' ? '暂无数据' : $data.theOne.sceneName), 1)]),
        _: 1
      })]),
      _: 1
    }), _cache[148] || (_cache[148] = _createElementVNode("p", {
      style: {
        "font-weight": "bold"
      }
    }, "检测评语：", -1)), _createElementVNode("p", null, _toDisplayString($data.theOne.comment), 1)])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.dialogResultVisible,
    "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => $data.dialogResultVisible = $event),
    title: "退回提示",
    width: "40%"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_87, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-40px"
      },
      onClick: _cache[53] || (_cache[53] = $event => $data.dialogResultVisible = false)
    }, {
      default: _withCtx(() => [...(_cache[152] || (_cache[152] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), $data.RecordFlag != 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      style: {
        "margin-top": "-40px",
        "margin-right": "50px"
      },
      type: "primary",
      onClick: _cache[54] || (_cache[54] = $event => $options.formResultSave('formResult'))
    }, {
      default: _withCtx(() => [...(_cache[153] || (_cache[153] = [_createTextVNode("确认", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true), $data.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      style: {
        "margin-top": "-40px",
        "margin-right": "50px"
      },
      type: "primary",
      onClick: _cache[55] || (_cache[55] = $event => $options.formResultSave2('formResult'))
    }, {
      default: _withCtx(() => [...(_cache[154] || (_cache[154] = [_createTextVNode("确认", -1)]))]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formResult,
      ref: "formResult",
      rules: $data.rules,
      "status-icon": "",
      "label-width": "120px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "退回去向",
        prop: "recStatus"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_group, {
          modelValue: $data.formResult.recStatus,
          "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => $data.formResult.recStatus = $event)
        }, {
          default: _withCtx(() => [$data.RecordFlag != 4 ? (_openBlock(), _createBlock(_component_el_radio_button, {
            key: 0,
            label: 0
          }, {
            default: _withCtx(() => [...(_cache[149] || (_cache[149] = [_createTextVNode("重新编辑", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), $data.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_radio_button, {
            key: 1,
            label: 5
          }, {
            default: _withCtx(() => [...(_cache[150] || (_cache[150] = [_createTextVNode("审核", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true), $data.RecordFlag == 4 ? (_openBlock(), _createBlock(_component_el_radio_button, {
            key: 2,
            label: 2
          }, {
            default: _withCtx(() => [...(_cache[151] || (_cache[151] = [_createTextVNode("批准", -1)]))]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), $data.RecordFlag != 4 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        label: "退回原因",
        prop: "rejectDetail"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.formResult.rejectDetail,
          "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.formResult.rejectDetail = $event),
          "show-word-limit": "",
          clearable: "",
          autosize: {
            minRows: 4,
            maxRows: 8
          },
          style: {
            "width": "300px"
          },
          type: "textarea",
          maxlength: "200"
        }, null, 8, ["modelValue"])]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.tp,
    "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => $data.tp = $event),
    title: "检测图片",
    "lock-scroll": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_88, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.urls, url => {
      return _openBlock(), _createBlock(_component_el_image, {
        key: url,
        src: url,
        lazy: ""
      }, null, 8, ["src"]);
    }), 128))])]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_el_dialog, {
    title: "审批记录",
    modelValue: $data.timeline,
    "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => $data.timeline = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle({
          color: item.color
        }),
        class: "item"
      }, [_createElementVNode("div", {
        class: "point",
        style: _normalizeStyle({
          background: item.color
        })
      }, null, 4), index + 1 != $data.items.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "line",
        style: _normalizeStyle({
          background: $options.lineColor(item.color, index)
        })
      }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_91, [_createElementVNode("div", _hoisted_92, "操 作 人: " + _toDisplayString(item.person), 1), _createElementVNode("div", _hoisted_93, "状态变更: " + _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_94, "操作时间: " + _toDisplayString(item.time), 1)])], 4);
    }), 128))])])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    title: "审批记录",
    modelValue: $data.timeline2,
    "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => $data.timeline2 = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_95, [_createElementVNode("div", _hoisted_96, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items2, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle({
          color: item.color
        }),
        class: "item"
      }, [_createElementVNode("div", {
        class: "point",
        style: _normalizeStyle({
          background: item.color
        })
      }, null, 4), index + 1 != $data.items2.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "line",
        style: _normalizeStyle({
          background: $options.lineColor(item.color, index)
        })
      }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_97, [_createElementVNode("div", _hoisted_98, "操 作 人: " + _toDisplayString(item.person), 1), _createElementVNode("div", _hoisted_99, "状态变更: " + _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_100, "操作时间: " + _toDisplayString(item.time), 1)])], 4);
    }), 128))])])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    title: "审批记录",
    modelValue: $data.timeline3,
    "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => $data.timeline3 = $event)
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_101, [_createElementVNode("div", _hoisted_102, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items3, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        style: _normalizeStyle({
          color: item.color
        }),
        class: "item"
      }, [_createElementVNode("div", {
        class: "point",
        style: _normalizeStyle({
          background: item.color
        })
      }, null, 4), index + 1 != $data.items3.length ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "line",
        style: _normalizeStyle({
          background: $options.lineColor(item.color, index)
        })
      }, null, 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_103, [_createElementVNode("div", _hoisted_104, "操 作 人: " + _toDisplayString(item.person), 1), _createElementVNode("div", _hoisted_105, "状态变更: " + _toDisplayString(item.content), 1), _createElementVNode("div", _hoisted_106, "操作时间: " + _toDisplayString(item.time), 1)])], 4);
    }), 128))])])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.tcts,
    "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => $data.tcts = $event),
    title: "上传视频",
    "lock-scroll": false,
    width: "50%",
    draggable: "",
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_107, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      onClick: _cache[61] || (_cache[61] = $event => $data.tcts = false)
    }, {
      default: _withCtx(() => [...(_cache[156] || (_cache[156] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      type: "primary",
      onClick: _cache[62] || (_cache[62] = $event => $options.onSubmit($data.scopedata)),
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [...(_cache[157] || (_cache[157] = [_createTextVNode("确定", -1)]))]),
      _: 1
    }, 8, ["disabled"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.form,
      ref: "form",
      rules: $data.rules,
      "status-icon": "",
      "label-width": "160px"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "",
        "status-icon": "",
        "label-width": "160px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_upload, {
          class: "upload-demo",
          action: this.ip + '/detection/saveVideo',
          multiple: "",
          limit: 1,
          "show-file-list": true,
          "on-success": $options.uploadSuccess,
          "before-upload": $options.beforeAvatarUpload,
          "on-preview": $options.handlePreview,
          "on-progress": $options.onProgressTest,
          "on-remove": $options.handleRemove,
          "before-remove": $options.beforeRemove,
          "on-exceed": $options.handleExceed,
          "file-list": $data.fileList,
          ref: "upload"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            size: "small",
            type: "primary"
          }, {
            default: _withCtx(() => [...(_cache[155] || (_cache[155] = [_createTextVNode("选择文件", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["action", "on-success", "before-upload", "on-preview", "on-progress", "on-remove", "before-remove", "on-exceed", "file-list"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model", "rules"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.cxtj,
    "onUpdate:modelValue": _cache[92] || (_cache[92] = $event => $data.cxtj = $event),
    title: "查询条件",
    "lock-scroll": false,
    width: "80%",
    draggable: "",
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_109, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      onClick: _cache[90] || (_cache[90] = $event => $data.cxtj = false)
    }, {
      default: _withCtx(() => [...(_cache[159] || (_cache[159] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      type: "primary",
      onClick: _cache[91] || (_cache[91] = $event => $options.submitForm('formchecked', 'ThisForm', 0)),
      disabled: _ctx.disabled
    }, {
      default: _withCtx(() => [...(_cache[160] || (_cache[160] = [_createTextVNode("确定", -1)]))]),
      _: 1
    }, 8, ["disabled"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.formchecked,
      "label-position": "left",
      ref: "formRef",
      size: "medium",
      style: {
        "width": "auto",
        "height": "auto",
        "margin": "0 auto",
        "position": "relative"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("table", _hoisted_108, [_createElementVNode("tr", null, [_createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked1",
        size: "mini"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "检测时间大于等于",
          disabled: !$data.checkedA,
          modelValue: $data.formchecked.checked1,
          "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => $data.formchecked.checked1 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_date_picker, {
          modelValue: $data.ThisForm.f1_startTimeOutweigh,
          "onUpdate:modelValue": _cache[65] || (_cache[65] = $event => $data.ThisForm.f1_startTimeOutweigh = $event),
          "value-format": "YYYY-MM-DD HH:mm:ss",
          format: "YYYY/MM/DD HH:mm:ss",
          type: "datetime",
          disabled: !$data.formchecked.checked1,
          placeholder: "选择日期时间",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked8",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "工单ID",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked8,
          "onUpdate:modelValue": _cache[66] || (_cache[66] = $event => $data.formchecked.checked8 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.orderId,
          "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => $data.ThisForm.orderId = $event),
          disabled: !$data.formchecked.checked8,
          onkeyup: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
          style: {
            "width": "150px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked7",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "检测人员",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked7,
          "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => $data.formchecked.checked7 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.userAlias,
          "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => $data.ThisForm.userAlias = $event),
          disabled: !$data.formchecked.checked7,
          style: {
            "width": "150px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "使用单位",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked3,
          "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => $data.formchecked.checked3 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.unit,
          "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => $data.ThisForm.unit = $event),
          disabled: !$data.formchecked.checked3,
          style: {
            "width": "150px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })])]), _createElementVNode("tr", null, [_createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked2",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "检测时间小于等于",
          disabled: !$data.checkedA,
          modelValue: $data.formchecked.checked2,
          "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => $data.formchecked.checked2 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_date_picker, {
          modelValue: $data.ThisForm.f2_startTimeLessthen,
          "onUpdate:modelValue": _cache[73] || (_cache[73] = $event => $data.ThisForm.f2_startTimeLessthen = $event),
          disabled: !$data.formchecked.checked2,
          type: "datetime",
          "value-format": "YYYY-MM-DD HH:mm:ss",
          format: "YYYY/MM/DD HH:mm:ss",
          placeholder: "选择日期时间",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked9",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "电梯ID",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked9,
          "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => $data.formchecked.checked9 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.liftId,
          "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => $data.ThisForm.liftId = $event),
          modelModifiers: {
            number: true
          },
          disabled: !$data.formchecked.checked9,
          onkeyup: "value=value.replace(/^(0+)|[^\\dT#]+/g,'')",
          style: {
            "width": "150px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "物业",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked6,
          "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => $data.formchecked.checked6 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.areaName,
          "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => $data.ThisForm.areaName = $event),
          disabled: !$data.formchecked.checked6,
          style: {
            "width": "150px",
            "margin-left": "27px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "产品编号",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked4,
          "onUpdate:modelValue": _cache[78] || (_cache[78] = $event => $data.formchecked.checked4 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.liftNum,
          "onUpdate:modelValue": _cache[79] || (_cache[79] = $event => $data.ThisForm.liftNum = $event),
          disabled: !$data.formchecked.checked4,
          style: {
            "width": "150px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })])]), _createElementVNode("tr", null, [_createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "使用登记证编号",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked5,
          "onUpdate:modelValue": _cache[80] || (_cache[80] = $event => $data.formchecked.checked5 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.loginNum,
          "onUpdate:modelValue": _cache[81] || (_cache[81] = $event => $data.ThisForm.loginNum = $event),
          disabled: !$data.formchecked.checked5,
          style: {
            "width": "190px",
            "margin-left": "15px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "注册代码",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked10,
          "onUpdate:modelValue": _cache[82] || (_cache[82] = $event => $data.formchecked.checked10 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.lifeRegistCode,
          "onUpdate:modelValue": _cache[83] || (_cache[83] = $event => $data.ThisForm.lifeRegistCode = $event),
          disabled: !$data.formchecked.checked10,
          style: {
            "width": "135px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "使用单位代码",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked11,
          "onUpdate:modelValue": _cache[84] || (_cache[84] = $event => $data.formchecked.checked11 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.unitCode,
          "onUpdate:modelValue": _cache[85] || (_cache[85] = $event => $data.ThisForm.unitCode = $event),
          disabled: !$data.formchecked.checked11,
          style: {
            "width": "100px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "监察识别码",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked12,
          "onUpdate:modelValue": _cache[86] || (_cache[86] = $event => $data.formchecked.checked12 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_input, {
          modelValue: $data.ThisForm.superviseCode,
          "onUpdate:modelValue": _cache[87] || (_cache[87] = $event => $data.ThisForm.superviseCode = $event),
          disabled: !$data.formchecked.checked12,
          style: {
            "width": "150px"
          }
        }, null, 8, ["modelValue", "disabled"])]),
        _: 1
      })]), _createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        size: "medium"
      }, {
        default: _withCtx(() => [...(_cache[158] || (_cache[158] = [_createElementVNode("div", {
          style: {
            "margin": "0 auto"
          }
        }, null, -1)]))]),
        _: 1
      })]), _createElementVNode("tr", null, [_createElementVNode("td", null, [this.RecordFlag == 3 ? (_openBlock(), _createBlock(_component_el_form_item, {
        key: 0,
        style: {
          "float": "left"
        },
        label: "",
        prop: "checked6",
        size: "mini",
        class: "formItem"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_checkbox, {
          label: "状态",
          disabled: !$data.checkedB,
          modelValue: $data.formchecked.checked13,
          "onUpdate:modelValue": _cache[88] || (_cache[88] = $event => $data.formchecked.checked13 = $event)
        }, null, 8, ["disabled", "modelValue"]), _createVNode(_component_el_select, {
          modelValue: $data.ThisForm.recStatus,
          "onUpdate:modelValue": _cache[89] || (_cache[89] = $event => $data.ThisForm.recStatus = $event),
          clearable: "",
          disabled: !$data.formchecked.checked13
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "已批准",
            value: "3"
          }), _createVNode(_component_el_option, {
            label: "已上传",
            value: "4"
          })]),
          _: 1
        }, 8, ["modelValue", "disabled"])]),
        _: 1
      })) : _createCommentVNode("", true)])])])]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.shsj,
    "onUpdate:modelValue": _cache[96] || (_cache[96] = $event => $data.shsj = $event),
    title: "选择审核时间",
    "lock-scroll": false,
    width: "50%",
    draggable: "",
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_111, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      onClick: _cache[94] || (_cache[94] = $event => $data.shsj = false)
    }, {
      default: _withCtx(() => [...(_cache[161] || (_cache[161] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      type: "primary",
      onClick: _cache[95] || (_cache[95] = $event => $options.Audit($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[162] || (_cache[162] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.sh_form,
      "label-position": "left",
      ref: "formRef",
      size: "medium",
      style: {
        "width": "auto",
        "height": "auto",
        "margin": "0 auto",
        "position": "relative"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("table", _hoisted_110, [_createElementVNode("tr", null, [_createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "审核时间",
        size: "mini"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $data.ThisForm.new_shsj,
          "onUpdate:modelValue": _cache[93] || (_cache[93] = $event => $data.ThisForm.new_shsj = $event),
          "value-format": "YYYY-MM-DD",
          format: "YYYY/MM/DD",
          type: "date",
          placeholder: "选择日期",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      })])])])]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.pzsj,
    "onUpdate:modelValue": _cache[100] || (_cache[100] = $event => $data.pzsj = $event),
    title: "选择批准时间",
    "lock-scroll": false,
    width: "50%",
    draggable: "",
    "close-on-click-modal": false,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_113, [_createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      onClick: _cache[98] || (_cache[98] = $event => $data.pzsj = false)
    }, {
      default: _withCtx(() => [...(_cache[163] || (_cache[163] = [_createTextVNode("关闭", -1)]))]),
      _: 1
    }), _createVNode(_component_el_button, {
      style: {
        "margin-top": "-50px"
      },
      type: "primary",
      onClick: _cache[99] || (_cache[99] = $event => $options.Audit($data.scopedata))
    }, {
      default: _withCtx(() => [...(_cache[164] || (_cache[164] = [_createTextVNode("确定", -1)]))]),
      _: 1
    })])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.pz_form,
      "label-position": "left",
      ref: "formRef",
      size: "medium",
      style: {
        "width": "auto",
        "height": "auto",
        "margin": "0 auto",
        "position": "relative"
      }
    }, {
      default: _withCtx(() => [_createElementVNode("table", _hoisted_112, [_createElementVNode("tr", null, [_createElementVNode("td", null, [_createVNode(_component_el_form_item, {
        style: {
          "float": "left"
        },
        label: "批准时间",
        size: "mini"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_date_picker, {
          modelValue: $data.ThisForm.new_pzsj,
          "onUpdate:modelValue": _cache[97] || (_cache[97] = $event => $data.ThisForm.new_pzsj = $event),
          "value-format": "YYYY-MM-DD",
          format: "YYYY/MM/DD",
          type: "date",
          placeholder: "选择日期",
          style: {
            "width": "200px"
          }
        }, null, 8, ["modelValue"])]),
        _: 1
      })])])])]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue"])], 64);
}